export const SUP_SOURCING_LOADER = {
  desktop: `
  <!-- Banners -->
  <div class="cui cui-grid cui-container">
    <div class="cui-skeleton-paragraph__content -spacing--bottom-10 -spacing--top-40" style="width: 100%">
      <div class="cui-skeleton__item" style="height: 300px"></div>
    </div>
    <div class="cui-skeleton-paragraph__content -spacing--bottom-40 " style="width: 100%">
      <div class="cui-skeleton__item" style="height: 300px"></div>
    </div>
    <!-- Terms section -->
    <div class="cui-skeleton-heading -size--large -spacing--bottom-120 -spacing--top-8 -resolution--desktop">
      <div class="cui-skeleton-heading__content -spacing--bottom-40" style="width: 50%">
        <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
    <div class="cui-skeleton-paragraph__content -spacing--bottom-40 " style="width: 100%">
      <div class="cui-skeleton__item" style="height: 80px"></div>
    </div>
    <div class="cui-skeleton-input -size--medium -spacing--bottom-40 -resolution--desktop">
      <div class="cui-skeleton-input__content" style="width: min(100%, 320px)">
        <div class="cui-skeleton__item cui-skeleton-input__field"></div>
      </div>
    </div>
  </div>
  <div class="cui-row -spacing--top-96" >
    <div class="cui-col-xl-3 cui-col-md-3 cui-col-sm-8">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-8">
        <div class="cui-skeleton__item" style="width: 100%; height: 170px"></div>
      </div>
    </div>
    <div class="cui-col-xl-3 cui-col-md-3 cui-col-sm-8">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-8">
        <div class="cui-skeleton__item" style="width: 100%; height: 170px"></div>
      </div>
    </div>
    <div class="cui-col-xl-3 cui-col-md-3 cui-col-sm-8">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-8">
        <div class="cui-skeleton__item" style="width: 100%; height: 170px"></div>
      </div>
    </div>
    <div class="cui-col-xl-3 cui-col-md-3 cui-col-sm-8">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-8">
        <div class="cui-skeleton__item" style="width: 100%; height: 170px"></div>
      </div>
    </div>
    <div class="cui-col-xl-3 cui-col-md-3 cui-col-sm-8">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-8">
        <div class="cui-skeleton__item" style="width: 100%; height: 170px"></div>
      </div>
    </div>
    <div class="cui-col-xl-3 cui-col-md-3 cui-col-sm-8">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-8">
        <div class="cui-skeleton__item" style="width: 100%; height: 170px"></div>
      </div>
    </div>
    <div class="cui-col-xl-3 cui-col-md-3 cui-col-sm-8">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-8">
        <div class="cui-skeleton__item" style="width: 100%; height: 170px"></div>
      </div>
    </div>
    <div class="cui-col-xl-3 cui-col-md-3 cui-col-sm-8">
      <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-8">
        <div class="cui-skeleton__item" style="width: 100%; height: 170px"></div>
      </div>
    </div>
   </div>
   <!-- Supplier Code of Conduct -->
   <div class="cui-skeleton-heading -size--large -spacing--top-8 -resolution--desktop">
    <div class="cui-skeleton-heading__content -spacing--bottom-40" style="width: 50%">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
   </div>
   <div class="cui-row " >
     <div class="cui-col-xl-3 cui-col-md-3 cui-col-sm-8">
       <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-8">
         <div class="cui-skeleton__item" style="width: 100%; height: 170px"></div>
       </div>
     </div>
     <div class="cui-col-xl-3 cui-col-md-3 cui-col-sm-8">
       <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-8">
         <div class="cui-skeleton__item" style="width: 100%; height: 170px"></div>
       </div>
     </div>
     <div class="cui-col-xl-3 cui-col-md-3 cui-col-sm-8">
       <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-8">
         <div class="cui-skeleton__item" style="width: 100%; height: 170px"></div>
       </div>
     </div>
     <div class="cui-col-xl-3 cui-col-md-3 cui-col-sm-8">
       <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-8">
         <div class="cui-skeleton__item" style="width: 100%; height: 170px"></div>
       </div>
     </div>
    </div>
    <!-- Portals -->
   <div class="cui-skeleton-heading -size--large -spacing--top-8 -resolution--desktop">
    <div class="cui-skeleton-heading__content -spacing--bottom-40" style="width: 50%">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
   </div>
   <div class="cui-row " >
     <div class="cui-col-xl-3 cui-col-md-3 cui-col-sm-8">
       <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-8">
         <div class="cui-skeleton__item" style="width: 100%; height: 170px"></div>
       </div>
     </div>
     <div class="cui-col-xl-3 cui-col-md-3 cui-col-sm-8">
       <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-8">
         <div class="cui-skeleton__item" style="width: 100%; height: 170px"></div>
       </div>
     </div>
     <div class="cui-col-xl-3 cui-col-md-3 cui-col-sm-8">
       <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-8">
         <div class="cui-skeleton__item" style="width: 100%; height: 170px"></div>
       </div>
     </div>
     <div class="cui-col-xl-3 cui-col-md-3 cui-col-sm-8">
       <div class="cui-skeleton-rectangle -is--block -spacing--bottom-80 -spacing--top-8">
         <div class="cui-skeleton__item" style="width: 100%; height: 170px"></div>
       </div>
     </div>
    </div>
    <!-- Accounts Payable support -->
    <div class="cui-skeleton-rectangle -spacing--top-96 -is--block -spacing--bottom-80 -spacing--top-8">
      <div class="cui-skeleton__item" style="width: 100%; height: 400px"></div>
    </div>
</div>
`
};
